"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.equal = equal;
exports.default = void 0;

var _iterable = require("../../internal/iterable");

var _zipAll = require("../$zip-all/zip-all");

var _slice = require("../$slice/slice");

const noItem = {};
const zipAllConfig = {
  filler: noItem
};

function equal(iterables) {
  if (iterables.length <= 1) {
    return true;
  }

  const wrappedIterables = iterables;

  for (const allItems of (0, _zipAll.zipAll)(wrappedIterables, zipAllConfig)) {
    const firstItem = allItems[0];

    for (const item of (0, _slice.simpleSlice)(allItems, 1, Infinity)) {
      if (item !== firstItem) {
        return false;
      }
    }
  }

  return true;
}

var _default = (0, _iterable.iterableCurry)(equal, {
  reduces: true,
  variadic: true
});

exports.default = _default;